/**
  * @class meleNotif
  * @description
  *
  * # Purpose
  * Implements `<mele-notif>` custom web element.
  *
  * # Use
  * Create element in HTML:
  * ```
  * parentEl.innerHTML += '<mele-notif></mele-notif>';
  * ```
  * Create element in JavaScript:
  * ```
  * parentEl.appendChildren({
  *   tag: 'mele-notif',
  *   ... other attributes ...
  * })
  * ```
  *
  * # Implementation notes
  *
  */

import meleItem from 'meleItem'

const PROPERTIES = _.extend({}, {
  actions: { type: 'array', description: 'Actions to resolve notification' },
  actionsposition: { type: 'string', description: 'position of actions', enum: ['right', 'left', 'center'] },
  color: { type: 'string', description: 'color label on the notification' },
  // time: {type: "string", description: "Time when the notification was published"},
  timeout: { type: 'string', description: 'Time until the notification disapears' },
  priority: { type: 'number', description: 'Priority of the notification - higher number has a higher priority' },
  eventAction: { type: 'function', description: 'Called when action button is clicked' },
}, meleItem._properties)

export default class meleNotif extends meleItem {
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Creates internal DOM structure.
  */
  init() {
    super.init()
    this._actions = this.appendChildren({ tag: 'mele-actions', class: `empty ${this.classScope('actions')}` })
  } // init

  colorChanged() {}

  // ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // /**
  //  * Handle change of attribute "time"
  // */
  // timeChanged(value) {
  //   if(value !== 0) {
  //     this.value = moment.unix(value).fromNow();
  //   }
  // } // timeChanged

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "timeout"
  */
  timeoutChanged(value, old) {
    if(this.timeout === '') return
    if(this.lastTimeout) {
      clearTimeout(this.lastTimeout)
    }
    this.lastTimeout = setTimeout(()=>{
      this.remove()
    }, value*1000)
  } // timeoutChanged

  _setActionsEmptyFlag() {
    if(this._actions.childElementCount < 1) {
      this._actions.classList.add('empty')
    } else {
      this._actions.classList.remove('empty')
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "actions"
  */
  actionspositionChanged(value) {
    if(value) {
      this.actionsposition = value
      this._actions.classList.remove('left', 'center', 'right')
      this._actions.classList.add(_.toString(value))
    } else {
      this.actionsposition = 'center'
      this._actions.classList.add('center')
    }
  } // actionspositionChanged

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "actions"
  */
  actionsChanged(value) {
    this._actions.innerHTML = ''
    const me=this

    value.forEach(action=>{
      if(typeof (action)==='string') {
        action = { key: action, label: action }
      }
      if(_.isObjectLike(action)) {
        action = _.extend({ tag: 'mele-button', type: 'notify', class: this.classScope('button') }, action)
        action.eventButtonClicked = (btn)=>{
          me.eventAction(me, btn.key)
        }
        this._actions.appendChildren(action)
      }
    })
    this.actionspositionChanged()
    this._setActionsEmptyFlag()
  } // actions

  priorityChanged(value) {
    if(this.priority === '') return
    if(value <= 10) {
      this.class = 'high'
    } else if (value > 10 && value <= 20) {
      this.class = 'medium'
    } else if (value > 20 && value <= 30) {
      this.class = 'low'
    } else {
      this.class = 'default'
    }
  }

  eventAction(notif, action) {
    this.publish('mmNotifyActionClicked', { key: notif.key, action })
  }
} // meleNotif

meleNotif._properties = PROPERTIES
meleNotif.observedAttributes = _.keys(PROPERTIES)

window.customElements.define('mele-notif', meleNotif)
